export const REQUEST_OPTIONS = {
  DEFAULT: {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  },
};